module.exports = __webpack_public_path__ + "img/bateriaconcarga.34cd05da.png";